import { observer } from 'mobx-react-lite'
import { useUi } from '@/stores/RootStore'
import { AutoWithdrawalsPage } from './AutoWithdrawalsPage'
import { ReceivePage } from './ReceivePage'
import { SendPage } from './SendPage'
import { WalletsPage } from './WalletsPage'

/**
 * Диалоги кабинета — один открытый за раз, поверх любой страницы.
 * Живут в оболочке (AppLayout), а не в обзоре: открыть отправку можно
 * и с истории, и с админского обзора, и окно не должно зависеть от того,
 * какая страница под ним.
 */
export const CabinetDialogs = observer(function CabinetDialogs() {
  const ui = useUi()
  const dialog = ui.dialog
  if (dialog === null) return null
  switch (dialog.kind) {
    case 'wallets': return <WalletsPage />
    case 'auto': return <AutoWithdrawalsPage />
    case 'send': return <SendPage key={dialog.currency} currency={dialog.currency} />
    case 'receive': return <ReceivePage key={dialog.currency} currency={dialog.currency} />
  }
})
